import React from 'react';
import {HELP_WIDGET_ID} from 'config/srm.config';
import HelpWidgetLoad from './HelpWidgetLoad';

const URI = `https://widget.freshworks.com/widgets/${HELP_WIDGET_ID}.js`;
const HelpWidget = () => <HelpWidgetLoad src={URI} async={true} defer={true} />;

export default HelpWidget;
